import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { navigate } from '../router';
import { stytch } from '../auth/session.ts';

import '../components/luna-auth-card/luna-auth-card';

@customElement('app-auth-callback')
export class AppAuthCallback extends LitElement {
  async firstUpdated() {
    const params = new URLSearchParams(window.location.search);
    const tokenType = params.get('stytch_token_type');
    const token = params.get('token');

    if (!tokenType || !token) {
      return navigate('/login');
    }

    switch (tokenType) {
      case 'oauth':
        await stytch.oauth.authenticate(token, { session_duration_minutes: 60 });
        break;
      case 'magic_links':
        await stytch.magicLinks.authenticate(token, { session_duration_minutes: 60 });
        break;
      default:
        return navigate('/login');
    }

    const redirect = localStorage.getItem('postLoginRedirect') || '';
    localStorage.removeItem('postLoginRedirect');

    navigate(redirect);
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <luna-auth-card>
        <h1 class="mbw-type-title-section">Signing you in…</h1>
        <p>Please wait while your session is being created.</p>
      </luna-auth-card>
    `;
  }
}
